import { createSelector } from 'reselect'

export const getCitiesByCountryWithinRegions = createSelector(
  (state) => state.geoObjects && state.geoObjects.cities && state.geoObjects.cities.byCountryWithinRegions
    ? state.geoObjects.cities.byCountryWithinRegions : {},
  (cities) => cities
)
